import * as I from 'immutable';
import React from 'react';

import {ApiOrganization, ApiOrganizationUser} from 'app/modules/Remote/Organization';
import {LoggedInAuth, LoggedInUserActions} from 'app/providers/AuthProvider';

import AppNav from '../AppNav';
import {NavSidebarContainer} from '../NavSidebar';

interface Props {
  history: any;
  auth: LoggedInAuth;
  profile: I.ImmutableOf<ApiOrganizationUser>;
  organization: I.ImmutableOf<ApiOrganization>;
  loggedInUserActions: LoggedInUserActions;
}

interface LayoutWrapperProps extends Props {
  children: React.ReactNode;
}

export const LayoutWrapper: React.FunctionComponent<LayoutWrapperProps> = ({
  history,
  profile,
  organization,
  loggedInUserActions,
  children,
}) => {
  return (
    <>
      <AppNav
        history={history}
        organization={organization}
        profile={profile}
        selectedProject={null}
        loggedInUserActions={loggedInUserActions}
      />

      <NavSidebarContainer history={history}>{children}</NavSidebarContainer>
    </>
  );
};
